import { render, staticRenderFns } from "./ProjectGeneralTable.vue?vue&type=template&id=494a52a7&scoped=true"
import script from "./ProjectGeneralTable.vue?vue&type=script&lang=ts"
export * from "./ProjectGeneralTable.vue?vue&type=script&lang=ts"
import style0 from "./ProjectGeneralTable.vue?vue&type=style&index=0&id=494a52a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494a52a7",
  null
  
)

export default component.exports